<h3 class="!m-0 !font-bold">{{ template().name }}</h3>
<div class="flex grow text-xs opacity-50">
  @if (template().description) {
    {{ template().description }}
  } @else {
    No Description
  }
</div>
@if (template().tags) {
  <div class="flex flex-wrap gap-1 opacity-50">
    @for (tag of template().tags; track tag) {
      <pr-icon-chip icon="sell">{{ tag }}</pr-icon-chip>
    }
  </div>
}

@if (flatButton()) {
  <button mat-flat-button color="primary" (click)="selected.emit(template())">
    {{ selectLabel() }}
  </button>
} @else {
  <button
    mat-stroked-button
    color="primary"
    (click)="selected.emit(template())"
  >
    {{ selectLabel() }}
  </button>
}
